import { AbsoluteNumberInput, FloatNumberInput } from '@/components';
import { Dispatch } from 'react';
import { Label } from '@e2n/ui';
import { useTranslation } from 'react-i18next';
import { ZieleEditForm, ZieleFormReducerAction } from '../types';
import { FormFieldWrapper } from '@/domain/controlling/pages/Umsatzplanung/components/FormFieldWrapper';
import { useTagebuchEinstellungen } from '@/domain/controlling/hooks/useTagebuchEinstellungen';
import { useStandortContext } from '@/features/standortContext/StandortContext';
import { AbsatzVorgabe } from '@/domain/controlling/entities';

export function AbsatzzielInputFields({
  dispatch,
  zieleForm,
}: {
  dispatch: Dispatch<ZieleFormReducerAction>;
  zieleForm: ZieleEditForm;
}) {
  const { t } = useTranslation();
  const { currentStandort } = useStandortContext();
  const {
    tagebuchEinstellungen: {
      absatzProduktivitaet: { absatzVorgabe },
    },
  } = useTagebuchEinstellungen(currentStandort.id);

  function handleUpdateAbsatzZiel(value: string) {
    dispatch({
      type: 'updateAbsatzZiel',
      values: {
        absatzZiel: value,
      },
    });
  }

  function handleUpdateAbsatzZielproduktiviatet(value: string) {
    dispatch({
      type: 'updateAbsatzZielproduktivitaet',
      values: {
        absatzZielproduktivitaet: value,
      },
    });
  }

  return (
    <div className="flex justify-between gap-4">
      <FormFieldWrapper>
        <Label htmlFor="absatzZiel">
          {t('domain.controlling.umsatzplanung.ziele.dialog.absatz.label')}
        </Label>
        <AbsoluteNumberInput
          id="absatzZiel"
          value={zieleForm.formValues.absatzZiel}
          onInput={(event) => handleUpdateAbsatzZiel(event.currentTarget.value)}
          unit={t('domain.controlling.umsatzplanung.units.stueck')}
        />
      </FormFieldWrapper>
      <FormFieldWrapper>
        <Label htmlFor="absatzZielproduktivitaet">
          {t(
            'domain.controlling.umsatzplanung.ziele.dialog.produktivitaet.label',
          )}
        </Label>
        <FloatNumberInput
          id="absatzZielproduktivitaet"
          value={zieleForm.formValues.absatzZielproduktivitaet}
          onInput={(event) =>
            handleUpdateAbsatzZielproduktiviatet(event.currentTarget.value)
          }
          onBlur={(event) =>
            handleUpdateAbsatzZielproduktiviatet(event.currentTarget.value)
          }
          unit={
            absatzVorgabe === AbsatzVorgabe.Stueck
              ? t('domain.controlling.umsatzplanung.units.Stk./Std.')
              : t('domain.controlling.umsatzplanung.units.mpt')
          }
        />
      </FormFieldWrapper>
    </div>
  );
}
